var map = {
	"./MICROBIUM": 109,
	"./MICROBIUM.png": 109,
	"./MICROBIUM.svg": 189,
	"./about-image": 113,
	"./about-image.png": 113,
	"./back": 114,
	"./back.svg": 114,
	"./background": 115,
	"./background.jpg": 115,
	"./catalog-promo/promo1000": 116,
	"./catalog-promo/promo1000.jpg": 116,
	"./catalog-promo/promo1176": 117,
	"./catalog-promo/promo1176.jpg": 117,
	"./catalog-promo/promo1560": 118,
	"./catalog-promo/promo1560.jpg": 118,
	"./catalog-promo/promo265": 119,
	"./catalog-promo/promo265.jpg": 119,
	"./catalog-promo/promo455": 120,
	"./catalog-promo/promo455.jpg": 120,
	"./catalog-promo/promo496": 121,
	"./catalog-promo/promo496.jpg": 121,
	"./close-black": 122,
	"./close-black.svg": 122,
	"./donate-banner": 123,
	"./donate-banner-mobile": 124,
	"./donate-banner-mobile.png": 124,
	"./donate-banner.png": 123,
	"./exclamation": 125,
	"./exclamation.svg": 125,
	"./favicon": 110,
	"./favicon-1.ico": 190,
	"./favicon-2.ico": 191,
	"./favicon.ico": 192,
	"./favicon.png": 110,
	"./favicon.svg": 193,
	"./footer-logo": 126,
	"./footer-logo.svg": 126,
	"./icons/dzen": 127,
	"./icons/dzen.svg": 127,
	"./icons/ok": 128,
	"./icons/ok.svg": 128,
	"./icons/search-icon": 129,
	"./icons/search-icon-bold": 130,
	"./icons/search-icon-bold.svg": 130,
	"./icons/search-icon.svg": 129,
	"./icons/telegram": 131,
	"./icons/telegram.svg": 131,
	"./icons/vk": 132,
	"./icons/vk.svg": 132,
	"./logo": 133,
	"./logo-2": 134,
	"./logo-2.png": 134,
	"./logo-home": 135,
	"./logo-home.png": 135,
	"./logo-microbius-1": 136,
	"./logo-microbius-1.png": 136,
	"./logo.svg": 133,
	"./manifest/microbius-120": 137,
	"./manifest/microbius-120.png": 137,
	"./manifest/microbius-128": 138,
	"./manifest/microbius-128.png": 138,
	"./manifest/microbius-144": 139,
	"./manifest/microbius-144.png": 139,
	"./manifest/microbius-152": 140,
	"./manifest/microbius-152.png": 140,
	"./manifest/microbius-180": 141,
	"./manifest/microbius-180.png": 141,
	"./manifest/microbius-192": 142,
	"./manifest/microbius-192.png": 142,
	"./manifest/microbius-384": 143,
	"./manifest/microbius-384.png": 143,
	"./manifest/microbius-512": 144,
	"./manifest/microbius-512.png": 144,
	"./manifest/microbius-72": 145,
	"./manifest/microbius-72.png": 145,
	"./manifest/microbius-96": 146,
	"./manifest/microbius-96.png": 146,
	"./marketing-banner/arrow": 147,
	"./marketing-banner/arrow.svg": 147,
	"./marketing-banner/installation-1": 148,
	"./marketing-banner/installation-1-mob": 149,
	"./marketing-banner/installation-1-mob.png": 149,
	"./marketing-banner/installation-1.png": 148,
	"./marketing-banner/installation-2": 150,
	"./marketing-banner/installation-2.png": 150,
	"./marketing-banner/installation-3": 151,
	"./marketing-banner/installation-3.png": 151,
	"./marketing-banner/logo": 152,
	"./marketing-banner/logo.png": 152,
	"./marketing-banner/marketing-banner-bg": 153,
	"./marketing-banner/marketing-banner-bg.jpg": 153,
	"./microbius-logo": 154,
	"./microbius-logo-mini-ng": 155,
	"./microbius-logo-mini-ng.png": 155,
	"./microbius-logo-ng": 156,
	"./microbius-logo-ng.png": 156,
	"./microbius-logo.png": 154,
	"./next": 157,
	"./next.svg": 157,
	"./share/copy": 158,
	"./share/copy.svg": 158,
	"./share/dzen": 159,
	"./share/dzen.svg": 159,
	"./share/email": 160,
	"./share/email.svg": 160,
	"./share/ok": 161,
	"./share/ok.svg": 161,
	"./share/telegram": 162,
	"./share/telegram.svg": 162,
	"./share/vk": 163,
	"./share/vk.svg": 163,
	"./share/whatsapp": 164,
	"./share/whatsapp.svg": 164,
	"./umoney": 165,
	"./umoney.svg": 165,
	"./vk-pay": 166,
	"./vk-pay.svg": 166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 188;